'use client';
import React, { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    location: 'Mumbai',
    date: '10th Jan 2026',
    title: 'Got Hassle-free Personal Loan',
    text: 'I had an excellent experience with KARFIN while applying for a personal loan. The team guided me through every step clearly, helped me understand the details, and ensured the process went smoothly. Their assistance made my loan journey completely hassle-free.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Priya Sharma',
    location: 'Delhi',
    date: '12th Jan 2026',
    title: 'Best Support for Home Loan Approval',
    text: 'After facing multiple rejections from banks, KARFIN went above and beyond to guide me through the process, understand my situation, and ensure my home loan application was successfully approved. Their professionalism and dedication truly made the difference.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Amit Patel',
    location: 'Ahmedabad',
    date: '15th Jan 2026',
    title: 'Stress-free Business Loan Process',
    text: 'There was a complication with my KYC verification. KARFIN handled it swiftly and professionally. They ensured regular updates, explained resolution steps clearly, and resolved the issue quickly. The loan process was completed without further delays.',
    rating: 5,
  },
  {
    id: 4,
    name: 'Sunita Verma',
    location: 'Bangalore',
    date: '18th Jan 2026',
    title: 'Perfect for Financial Solutions',
    text: 'Recently I had a conversation with the KARFIN team. Thanks for providing a better solution in a very short period of time with very nice behaviour. The credit score check was free and the loan offers were the best I found anywhere.',
    rating: 5,
  },
  {
    id: 5,
    name: 'Vikram Singh',
    location: 'Pune',
    date: '20th Jan 2026',
    title: 'Excellent Support for Credit Report',
    text: 'I would like to express my sincere appreciation to the KARFIN team who assisted me in downloading my credit report. They were extremely patient, knowledgeable, and efficient, and resolved the issue within just a few minutes. Excellent service!',
    rating: 5,
  },
  {
    id: 6,
    name: 'Meena Iyer',
    location: 'Chennai',
    date: '22nd Jan 2026',
    title: 'Best Place for Taking Loans',
    text: 'I contacted KARFIN customer care with a few queries, and I am very satisfied with the support I received. The representative was polite, patient, and explained everything clearly. My questions were resolved properly and the overall experience was smooth.',
    rating: 5,
  },
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg
          key={i}
          className={`w-4 h-4 ${i < count ? 'text-yellow-400' : 'text-gray-600'}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;
  const totalPages = Math.ceil(testimonials.length / itemsPerPage);
  const visibleTestimonials = testimonials.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl font-bold text-gray-900">What our customers say</h2>
          <div className="flex gap-2">
            <button
              onClick={() => setCurrentPage(Math.max(0, currentPage - 1))}
              disabled={currentPage === 0}
              className="w-9 h-9 rounded-full border border-gray-300 flex items-center justify-center hover:border-primary hover:text-primary disabled:opacity-40 disabled:cursor-not-allowed transition-colors text-gray-500"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              onClick={() => setCurrentPage(Math.min(totalPages - 1, currentPage + 1))}
              disabled={currentPage === totalPages - 1}
              className="w-9 h-9 rounded-full border border-gray-300 flex items-center justify-center hover:border-primary hover:text-primary disabled:opacity-40 disabled:cursor-not-allowed transition-colors text-gray-500"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {visibleTestimonials.map((t) => (
            <div
              key={t.id}
              className="p-6 rounded-lg border border-gray-200 bg-white hover:border-orange-300 hover:shadow-md transition-all duration-300"
            >
              <h4 className="text-sm font-semibold text-gray-900 mb-2">{t.title}</h4>
              <p className="text-sm text-gray-500 leading-relaxed mb-4 line-clamp-4">{t.text}</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-900">{t.name}</p>
                  <p className="text-xs text-gray-400">{t.location} &bull; {t.date}</p>
                </div>
                <StarRating count={t.rating} />
              </div>
            </div>
          ))}
        </div>

        {/* Pagination dots */}
        <div className="flex justify-center gap-2 mt-6">
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentPage(i)}
              className={`h-2 rounded-full transition-all duration-300 ${
                i === currentPage ? 'w-6 bg-primary' : 'w-2 bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
